import { unified } from "unified";
import remarkParse from "remark-parse";

const INLINE_MARKDOWN_TYPES = new Set([
  "link",
  "linkReference",
  "image",
  "imageReference",
  "strong",
  "emphasis",
  "inlineCode",
  "delete",
  "break",
  "html",
]);

const BLOCK_MARKDOWN_TYPES = new Set([
  "heading",
  "list",
  "listItem",
  "blockquote",
  "code",
  "thematicBreak",
  "table",
  "tableRow",
  "tableCell",
]);

function nodeHasMarkdown(node) {
  if (!node || typeof node !== "object") return false;
  if (INLINE_MARKDOWN_TYPES.has(node.type) || BLOCK_MARKDOWN_TYPES.has(node.type)) {
    return true;
  }
  if (Array.isArray(node.children)) {
    return node.children.some(nodeHasMarkdown);
  }
  return false;
}

export const containsMarkdown = (text) => {
  if (!text) return false;
  // Fast path for common chat markdown (incl. single-paragraph links).
  if (
    /\[(?:\\.|[^\]])+\]\((?:\\.|[^)])+\)/.test(text) ||
    /(\*\*|__|\*|_|~~|`)[\s\S]+?\1/.test(text) ||
    /(^|\n)\s{0,3}(#{1,6}\s|[-*+]\s|\d+\.\s|>\s)/.test(text)
  ) {
    return true;
  }
  try {
    const tree = unified().use(remarkParse).parse(text);
    // Multiple block children usually means structured markdown.
    if (tree.children.length > 1) return true;
    return nodeHasMarkdown(tree);
  } catch (_) {
    return false;
  }
};

export const cleanMarkdownWhitespace = (text) => {
  if (!text) return text;
  let cleaned = text;
  cleaned = cleaned.replace(/\*\*([\s\S]*?)\*\*/g, (_, content) => {
    const m = content.match(/^(\s*)([\s\S]*?)(\s*)$/);
    if (!m || !m[2]) return content;
    return `${m[1]}**${m[2]}**${m[3]}`;
  });
  cleaned = cleaned.replace(/~~([\s\S]*?)~~/g, (_, content) => {
    const m = content.match(/^(\s*)([\s\S]*?)(\s*)$/);
    if (!m || !m[2]) return content;
    return `${m[1]}~~${m[2]}~~${m[3]}`;
  });
  return cleaned;
};
